<template>
  <div>
    <BaseTitle :title="$t('form.notification')" />
    <v-card class="mb-5">
      <slide-box class="pa-5" :value="true">
        <template>
          <div class="notification-content">
            <NotificationItem v-for="item in notif" :key="item.id" :item="item" />
            <NoData v-if="!notif.length" />
          </div>
        </template>
      </slide-box>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import SlideBox from '@/components/SlideBox';
import NotificationItem from '@/components/NotificationItem';
import NoData from '@/components/table/NoData';

export default {
  name: 'NotifIndex',
  components: {
    BaseTitle,
    SlideBox,
    NotificationItem,
    NoData
  },
  computed: {
    ...mapGetters({
      items: 'Notification/items'
    })
  },
  data: () => ({
    notif: []
  }),
  methods: {
    getData() {
      this.$store.dispatch('Notification/fetchList').catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    getNotif() {
      this.$store.dispatch('Notification/fetchData').then(res => {
        this.notif = res;
      });
    },
    birthdayGo() {
      this.$router.push({ name: 'personalBirthday' });
    }
  },
  created() {
    this.getData();
    this.getNotif();
  }
};
</script>

<style lang="scss" scoped>
.notification {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-content {
    font-size: 12px;
  }
}
.notification-item {
  display: flex;
  flex-direction: column;
  padding: 10px 0;

  &:last-child {
    border-bottom: 0;
  }

  &-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    text-align: center;
    line-height: 24px;
    margin-right: 12px;

    svg {
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.notif-content {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #acacac;

  &-icon {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }
  &-minute {
    padding-top: 10px;
    color: #ce8800;
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 100%;
      margin-bottom: 0;
    }
  }
}

.succ {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3fc;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-size: 18px;
    line-height: 20px;
    text-align: left;
  }
}
</style>
